export enum AircraftImageTypeEnum {
  Exterior = 1,
  Interior1 = 2,
  Interior2 = 3,
  Layout = 4,
}
